export default __webpack_public_path__ + "static/media/ill-es-sbj.b01fa61f.png";